import { TruncatedBadge } from '@/shared/ui';
import {
  Badge,
  Tooltip,
  TooltipProvider,
  TooltipTrigger,
  TooltipContent,
} from '@monksflow/monks-ui';

export function AudienceTags({
  audiences,
  maxVisibleTags = 2,
  exporting = false,
}: {
  audiences: string[];
  maxVisibleTags?: number;
  /** Print/export view: render every tag in full, no "+N" collapse, no truncation. */
  exporting?: boolean;
}) {
  if (!audiences.length) return null;

  // Export view: the "+N" overflow hides data behind a hover tooltip and
  // TruncatedBadge clips long names — neither survives a static PDF. Show all
  // tags in full with plain badges.
  if (exporting) {
    return (
      <div className="flex flex-wrap gap-1 justify-end">
        {audiences.map((tag) => (
          <Badge key={tag} variant="outline" roundness="full">
            {tag}
          </Badge>
        ))}
      </div>
    );
  }

  const visibleAudiences = audiences.slice(0, maxVisibleTags);
  const remainingAudiences = audiences.slice(maxVisibleTags);
  const hasMoreAudiences = remainingAudiences.length > 0;

  return (
    <div className="flex flex-wrap gap-1 justify-end">
      {visibleAudiences.map((tag) => (
        // secondary badge fill matches the card in dark mode; a border gives the edge.
        <TruncatedBadge key={tag} tag={tag} size="sm" className="dark:border-border" />
      ))}
      {hasMoreAudiences && (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <TruncatedBadge
                tag={`+${remainingAudiences.length}`}
                size="sm"
                className="dark:border-border"
              />
            </TooltipTrigger>
            <TooltipContent>
              <p>{remainingAudiences.join(', ')}</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      )}
    </div>
  );
}
